// extracted by mini-css-extract-plugin
export default {"selectWrapper":"KImtGrhc1PlcB319VUZw"};